export const FORM_NAME = 'MonthEndClose';

export const GET_MONTH_END_CLOSE = `app/${FORM_NAME}/GET_MONTH_END_CLOSE`;
export const GET_MONTH_END_CLOSE_SUCCESS = `app/${FORM_NAME}/GET_MONTH_END_CLOSE_SUCCESS`;
export const GET_MONTH_END_CLOSE_FAILURE = `app/${FORM_NAME}/GET_MONTH_END_CLOSE_FAILURE`;

export const SUBMIT_MONTH_END_CLOSE = `app/${FORM_NAME}/SUBMIT_MONTH_END_CLOSE`;
